import React from 'react';

import './BluehostAffiliate.scss';

export const BluehostAffiliate = () => (
	<div className="affiliates">
		<a
			href="https://www.bluehost.com/track/travishoki/"
			rel="noreferrer"
			target="_blank"
		>
			<img src="https://bluehost-cdn.com/media/partner/images/travishoki/160x40/160x40BW.png" />
		</a>
	</div>
);
